
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 26,
  viewBox: "0 0 18 26"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "arrow-right_17f83b88ab5f1d92__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.756878 0 0 0 0 0.756878 0 0 0 0 0.756878 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#arrow-right_17f83b88ab5f1d92__a)",
  transform: "translate(-17 -13)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  d: "M22.588 13.952a3.288 3.288 0 0 0-4.629 0 3.235 3.235 0 0 0-.19 4.39l.19.206L25.462 26l-7.503 7.452a3.235 3.235 0 0 0-.19 4.39l.19.206a3.289 3.289 0 0 0 4.42.19l.209-.19L34.72 26 22.588 13.952z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"26\" viewBox=\"0 0 18 26\">\r\n    <defs>\r\n        <filter id=\"o2b5wh016a\">\r\n            <feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 0.756878 0 0 0 0 0.756878 0 0 0 0 0.756878 0 0 0 1.000000 0\"/>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g filter=\"url(#o2b5wh016a)\" transform=\"translate(-1318 -2338) translate(86 2203) translate(1215 122)\">\r\n                    <path fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" d=\"M12.132.952c1.278-1.27 3.35-1.27 4.629 0 1.21 1.202 1.274 3.112.19 4.39l-.19.206L9.258 13l7.503 7.452c1.21 1.202 1.274 3.112.19 4.39l-.19.206c-1.211 1.203-3.135 1.266-4.42.19l-.209-.19L0 13 12.132.952z\" transform=\"matrix(-1 0 0 1 34.72 13)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow-right.17f83b88ab5f1d92b9c88c112cafeed5.svg"),
        {
          React: SvgArrowRight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      